<template>
  <div class="clearfix main_center"  v-loading.fullscreen.lock="loading">

    <div class="right-content clearfix busWinessRight">
      <pm-form-render
          v-if="customFormShow"
          ref="customFormRef"
      ></pm-form-render>
      <!--      <customForm-->
      <!--          v-if="customFormShow"-->
      <!--          ref="customFormRef"-->
      <!--          :auditHisTable.sync="auditHisTable"-->
      <!--          :entityId.sync="entityId"-->
      <!--          :categoryCode.sync="categoryCode"-->
      <!--          :baseURL.sync="baseURL">-->
      <!--      </customForm>-->

      <customFormOther
          v-if="customFormOtherShow"
          ref="customFormOtherRef"
          :auditHisTable.sync="auditHisTable"
          :entityId.sync="entityId"
          :categoryCode.sync="categoryCode"
          :purchaserMode.sync="purchaserMode"
          :nodeTitle.sync="nodeTitle"
          :nodeCode.sync="nodeCode">
      </customFormOther>

      <!--  见证情况-->
<!--      <witnessStatusForm v-if="witnessStatusFormList.indexOf(nodeCode) > -1 && areaBesidesCodeList.indexOf(stateData.orgInfo.regionCode) < 0" ref="witnessStatusForm"-->
<!--                         :projectInfo="paramMap"></witnessStatusForm>-->

      <el-card class="box-card" v-if="!customFormShow && !customFormOtherShow" style="height: 700px;position: relative;margin-bottom: 10px; z-index: 5" >
        <emptyInfo v-if="groupList.length == 0" :emptyMsg="'暂无表单数据'" ></emptyInfo>
      </el-card>


    </div>


    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <el-button v-if="exportExcelList.indexOf($route.query.routerPath) !== -1" @click="exportExcel()" size="small">导出</el-button>
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import customForm from '@/components/customForm';
import emptyInfo from '@/components/empty-info';
import customFormOther from '@/components/customForm/customFormOther';
import {mapState} from "vuex";
import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import qs from "qs";
import witnessStatusForm from '@/components/customForm/witnessStatusForm';

export default {
  components: {
    customForm,
    emptyInfo,
    customFormOther,
    witnessStatusForm
  },
  data(){
    return{
      id:"",
      baseURL:"",
      categoryCode:"",
      platformCode:"",
      pubServicePlatCode:"",
      customFormShow:true,
      nodeCode:"",
      nodeTitle:"",
      purchaserMode:"",// 采购方式
      customFormOtherShow:false,
      exportExcelList: ['/businessnodes/gc_022_list'],
      taskId:'',
      form:{
        id:'',
        historyid:'-1',
        processinstanceid:"",
        processinstancecreatedate:"",
        businessType:"",
        entityId:"",
        flowId:'',
        tenderProjectCode:'',
        bidSectionCode:'',
        projectCode:'',
        personHandle:1,  //人工干预见证
        rejectCode:'',
      },
      listNav:['项目信息','中选信息','附件信息'],
      auditForm:{
        isPass:null,
        suggest:''
      },
      dialogVisible:false,
      auditHisTable:[], // 变更历史
      loading:false,
      user:'',
      pageSize:10,//每页条数
      pageIndex:1,//当前页
      total:0,//总条数
      processSubmit:false,
      customFormData:{},
      filingCBtn:false,
      backCBtn:false,
      dataId: 0,
      paramMap: {
        tenderProjectCode: '',
        bidSectionCode: '',
        projectCode:'',
        applyCode:"",
        idcard:"",
        categoryCode: "",
      },
      formId: '',
      groupList: [],
      formInfo:{},
      tableData:[],


      // 见证情况列表
      witnessStatusFormList: ['GC00001', 'GC00043', 'GC00003', 'GC00004', 'GC00044', 'GC00006', 'GC00025', 'GC00026', 'GC00027', 'GC00029', 'GC00039', 'GC00041', 'GC00040',],
      // 排除区域列表 阳新 大冶
      areaBesidesCodeList: ['420281', '420222'],
    }
  },

  filters:{

  },
  created(){

  },
  computed: {
    ...mapState({
      stateData:state=>state.user
    }),
    businessType:function () {
      return this.form.businessType;
    },
    processinstanceid:function () {
      return this.form.processinstanceid;
    },
    entityId:function () {
      return this.form.entityId;
    },

  },

  activated() {
    // $route.query.id为首页通过 url跳转 带过来的参数
    this.id = (this.$route.query && this.$route.query.id ) || (this.$route.params && this.$route.params.id ) || '' ;
    this.formId = (this.$route.query && this.$route.query.formid ) || (this.$route.params && this.$route.params.formid ) || '' ;
    this.purchaserMode = this.$route.query && this.$route.query.purchaserMode
    this.getDetailById();
  },

  methods:{
    //列表查看进来根据id查询详情
    getDetailById(){

      if(this.id){

        // 查询基本信息及流程id
        this.$http.post('/businessFlow/flowNodeWitness/getInfo?entityId='+this.id,{}).then(res=>{
          var apires=res.data;
          if(apires.code==='1'){
            var data=apires.data;
            this.form = {...data}
            this.processSubmit = false;
            this.filingCBtn = false;
            this.backCBtn = false;
            this.paramMap.tenderProjectCode=data.tenderProjectCode || '';
            this.paramMap.bidSectionCode=data.bidSectionCode || '';
            this.paramMap.projectCode=data.projectCode || '';
            this.paramMap.entityId=data.entityId || '';
            this.paramMap.datasetCode=data.datasetCode || '';
            this.paramMap.thirdBusinessId=data.thirdBusinessId || '';
            this.getFormIdByFlowid(data.flowId);
            this.getAuditHisList()

          }
        })

      }else{
        this.$router.push({
          name:'home'
        })
      }

    },

    getAuditHisList(){
      // 查询见证记录数据
      this.$http.get('/auditHistory/getListAudit?entityId='+this.form.entityId).then(res=>{
        if(res.data.code==='1'){
          this.auditHisTable = res.data.data;
        }else{
          this.auditHisTable = [];
          this.$message({
            type:'error',
            message:res.data.msg
          })
        }
      })
    },

    exportExcel() {
      const params = {
        bidSectionCode: this.paramMap.bidSectionCode,
        tenderProjectCode: this.paramMap.tenderProjectCode,
      }
      const paramsObj = qs.stringify(params);
      const url = this.$http.adornUrl(`/api/attachment/downloadObjectReplyFile?${paramsObj}`);
      window.open(url);
    },

    // 返回
    back(){
      tabsCloseCurrentHandle();
      // this.$router.go(-1);
    },


    getFormIdByFlowid(flowid){
      // 根据jz_businessflow_witness的formid得到sys_flownode_config的form_id
      this.$http.get('/configs/sysFlowNodeConfig/get?id='+flowid).then(res=>{
        if(res.data.code==='1'){
          this.categoryCode = res.data.data.categoryCode;
          this.paramMap.categoryCode = res.data.data.categoryCode;
          this.nodeCode = res.data.data.nodeCode;
          this.nodeTitle = res.data.data.nodeName;

          this.paramMap.categoryIsOpen = res.data.data.categoryIsOpen;
          this.paramMap.categoryCode = res.data.data.categoryCode;
          if(res.data.data.enableCustom == 1){
            this.customFormShow = true;
            this.customFormOtherShow = false;
          }else{
            this.customFormShow = false;
            this.customFormOtherShow = true;
          }
          this.initData( res.data.data.formId);
        }else{
          this.$message({
            type:'error',
            message:res.data.msg
          })
        }

      })
    },




    // 获取自定义表单或定制化表单数据
    initData(formid) {



      // 支持自定义表单数据
      if(this.customFormShow) {
        if (formid=='' || formid === undefined  ) {
          this.$message.error('数据集无效')
          return
        }
        const that = this;
        setTimeout(function(){
          that.$refs.customFormRef.getCustomData(formid,that.paramMap);
        },100)

      }
      if(this.customFormOtherShow){ // 定制化表单数据
        const that = this;
        setTimeout(function(){
          that.$refs.customFormOtherRef.getCustomData(formid,that.paramMap,that.nodeCode,that.purchaserMode);
        },100)
      }



    },





  },
  deactivated(){
  },





}
</script>

<style lang="less" scope>


.right-content.busWinessRight{
  width: 100% !important;
}
.left-content.busWinessLeft{
  position: absolute;
  right: 40px;
  top: 20px;
  width: 160px;
  float: none !important;
  .left-navbar{
    width:150px;
    border:none;
  }
}


</style>
